import { useEffect } from 'react';
import * as Sentry from '@sentry/browser';
import { Layout } from '@tencent/tea-component';
import { useTranslation } from 'react-i18next';
import { useAppSelector, useAppDispatch } from '@store/index';
import { getIfShowAttendee } from '@store/ui/ui.slice';
import { getVoovAuthInfo } from '@store/authentication/authentication.slice';
import { getSelfUserMetaInfo } from '@store/user/user.slice';
import { getMeetingInfoInput, getMeetingSettings } from '@store/meeting/meeting.slice';
import { unMuteAudio, unMuteVideo } from '@store/media/media.thunk';

import { useListener } from '@utils/hooks/listenerHook';
import useImmersiveMode from '@utils/hooks/useImmersiveMode';
import usePageUnload from '@utils/hooks/usePageUnload';

import Attendee from '@component/attendee';
import RoomHeader from '@component/room-header';
import ControlZoom from '@component/control-zoom';
import Studio from '@component/studio';
import Speaker from '@component/speaker';

import './MeetingPage.css';
import { reportTimeEndJoinMeetingTotal } from 'src/report/aegis';
import { MediaSettingType, MediaSettingOfAudio, BOOL } from '@tencent/wemeet-websdk-next';
import { openToast } from '@component/toast';

const { Header, Body, Footer } = Layout;

export default function MeetingPage() {
  const { t } = useTranslation();
  // 是否显示右侧列表
  const ifShowAttendee = useAppSelector(getIfShowAttendee);
  const voovAuthInfo = useAppSelector(getVoovAuthInfo);
  const selfUserMetaInfo = useAppSelector(getSelfUserMetaInfo);
  const dispatch = useAppDispatch();
  const meetingInfoInput = useAppSelector(getMeetingInfoInput);
  const meetingSetting = useAppSelector(getMeetingSettings);

  useListener();
  usePageUnload();

  // 自动开麦开摄像头
  // TODO: 放到其他地方
  useEffect(() => {
    autoOpenMedia();

    // 计时结束：进房总耗时
    reportTimeEndJoinMeetingTotal();

    async function autoOpenMedia() {
      // @ts-ignore
      const audioSetting: MediaSettingOfAudio = meetingSetting.media_settings_list?.media_settings.find(
        (el) => el.type === MediaSettingType.UP_AUDIO,
      );
      // 是否入会静音
      const allowJoinMute = audioSetting ? audioSetting.mute_on_join === BOOL.true : false;
      console.log('audioSetting:', audioSetting);
      if (meetingInfoInput.enableAudio) {
        if (allowJoinMute) {
          openToast(t('主持人已将您静音。'));
          return;
        }
        await dispatch(unMuteAudio());
      }
      if (meetingInfoInput.enableVideo) {
        dispatch(unMuteVideo());
      }
    }
  }, []);

  const immersiveMode = useImmersiveMode();

  /**
   * 在入会成功后设置 Sentry 的通用信息
   *
   * TODO: 看看在哪里设置比较好
   * 1. 如果是在 join 方法结束后的话，需要在多个 join 方法后调用，代码有些重复
   * 2. 如果是 MeetingPage 的话，强依赖进会成功后才进入到这个 MeetingPage 的组建
   *
   * FIXME: 目前 setSelfUserMetaInfo 是在 join 方法后才调用的，
   * 目前漏了等候室的情况，如果是这种实现方法的话，之后可能还会漏其他情况
   */
  useEffect(() => {
    Sentry.configureScope((scope) => {
      const userId = voovAuthInfo?.userid;
      const openId = voovAuthInfo?.openId;
      const nickname = voovAuthInfo?.nickname;
      const tinyId = selfUserMetaInfo.av_user_id;
      const roomId = selfUserMetaInfo.av_room_id;

      scope.setUser({
        id: userId,
        openId,
        nickname,
        tinyId,
      });

      scope.setTag('user_identifier', openId); // 这个值是用来检索具体事件的，所以这个应该是用户能提供的，我们能方便拿到的。 setTag 第二个参数为字符串

      const url = `http://livetest.yy.isd.com?sdkAppId=${process.env.REACT_APP_SDK_APP_ID}&roomNum=${roomId}&userId=${tinyId}&openId=${openId}`;
      scope.setExtra('monitorUrl', url); // 拼接出 monitorUrl，在错误事件可以直接查看，setExtra 第二个参数可以为数字、字符串、对象

      scope.setExtra('metaData', {}); // setExtra 可以多次调用
    });
  }, []);

  return (
    <>
      <Layout className="meeting-page__layout">
        <Header
          className="meeting-page__header"
          style={{
            marginRight: ifShowAttendee ? '310px' : '0',
            top: immersiveMode ? '-30px' : '0',
          }}
        >
          <RoomHeader />
          {/* <div>header</div> */}
        </Header>

        <Body style={{ marginRight: ifShowAttendee ? '310px' : '0' }}>
          {/* TODO: 放到 studio 里 */}
          <Speaker />

          {/* <Content> */}
          {/* <Content.Body > */}
          <Studio />

          {/* 用户列表 */}
          <Attendee />
          {/* </Content.Body> */}
          {/* </Content> */}
        </Body>

        <Footer
          className="meeting-page__footer"
          style={{
            marginRight: ifShowAttendee ? '310px' : '0',
            bottom: immersiveMode ? '-68px' : '0',
          }}
        >
          <ControlZoom />
        </Footer>
      </Layout>
    </>
  );
}
